/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, mediaQuery } from 'utils/styles';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// APP STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default {
	app: {
		// background: color.greyDark,
		display: 'table',
		margin: '0 auto',
		position: 'relative',
		overflow: 'hidden',
		padding: '10px 0 10px 0',
		width: '100%',
		height: '100%', // takes the form of its parent iframe (though locally, we will add an inline style from the settings file to mimic the iframe width and height)

		// ~~~~ LOADED INTRO ANIMATION ~~~~ //
		// utilizing class set in comp based on timeout to localize these animations to only onload
		// animating header/footer here only so that when they're re-rendered when a new content renders they won't animate again
		'&.loading': {
			'& .header, .rewardsindicator, .footer': {
				animationDelay: '.6s',
				animationDuration: '.3s',
				animationFillMode: 'forwards',
			},
			'& .header': {
				transform: 'translate3d(0, -100%, 0)', // pull off screen to start
				animationName: 'slideInDown'
			},
			'& .rewardsindicator': {
				transform: 'translate3d(0, 600%, 0)', // pull off screen to start
				animationName: 'slideInUp'
			},
			'& .footer': {
				transform: 'translate3d(0, 500%, 0)', // pull off screen to start
				animationName: 'slideInUp'
			}
		}
	},
	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.short]: {
        app: { fontSize: '90%' }
    },
    [mediaQuery.shorter]: {
        app: { fontSize: '86%' }
    },
    [mediaQuery.shortest]: {
		app: { fontSize: '82%' }
	}
};
